import { Account } from "@/types";

export const showAdditionalServicesAccordion = (caseRecord: any) => {
  return caseRecord.accounts.reduce(
    (acc: boolean, { additionalServicesAccount }: Account) => !!additionalServicesAccount || acc,
    false
  );
};

export const noAccessToDashboardYet = (caseRecord: any) => {
  return caseRecord.source !== "express_form" && !caseRecord.formSubmittedAt;
};
